import * as React from "react";
const SvgFiRrCommentHeart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-heart_svg__a)">
      <path
        fill="#062147"
        d="M14.5 7a3.51 3.51 0 0 0-2.5.99 3.567 3.567 0 0 0-6 2.71c0 3.256 4.874 6.736 5.43 7.121a1 1 0 0 0 1.14 0c.556-.385 5.43-3.865 5.43-7.12A3.607 3.607 0 0 0 14.5 7M12 15.762c-1.742-1.33-4-3.56-4-5.062-.076-2.006 2.912-2.4 3-.246V11a1 1 0 0 0 2 0v-.546c.086-2.152 3.076-1.76 3 .246 0 1.5-2.26 3.732-4 5.062M12.834.028A12 12 0 0 0 .03 12.854C.47 19.208 6.082 24 13.082 24H19a5.006 5.006 0 0 0 5-5v-6.66A12.21 12.21 0 0 0 12.836.028M22 19a3 3 0 0 1-3 3h-5.917C7.049 22 2.4 18.1 2.024 12.716A10 10 0 0 1 12.7 2.024 10.2 10.2 0 0 1 22 12.34z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-heart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentHeart;
